import { useMemo } from "react";
import { Button, Flex, Table } from "antd";
import { StatusLabel, ActionButton } from "ui";
import { IconEye } from "components/icons/iconEye";
import { useAppStore } from "store";
import { useMagHomeManagementStore } from "pages/mag-home-management/store";
import {
  useDeleteArticleLine,
  useGetArticleLines,
} from "pages/mag-home-management/api";
import { MAG_HOME_ARTICLE_LINES_COLUMN } from "pages/mag-home-management/constant";
import { articleLine } from "pages/mag-home-management/type";
import { useArticleLinesTabStore } from "../store";

const ArticleLinesTable = () => {
  const setModalVisibility = useAppStore((state) => state.setModalVisibility);
  const { setArticlesModalData } = useArticleLinesTabStore((state) => state);
  const { setFormData, setIsEdit } = useMagHomeManagementStore(
    (state) => state
  );

  const { data, isPending } = useGetArticleLines();
  const { mutate: deleteArticleLineMutation } = useDeleteArticleLine();

  const dataSource = useMemo(() => {
    return (
      (data?.data ?? [])
        .sort(
          (i1: articleLine, i2: articleLine) => (i1.line ?? 0) - (i2.line ?? 0)
        )
        .map((item: articleLine, index: number) => {
          return {
            key: item.id,
            index: (
              <strong className="color-primary text-center">{index + 1}</strong>
            ),
            title: (
              <Flex vertical align="start" gap="5px">
                <strong className="color-primary text-center w-100">
                  {item?.title ?? "-"}
                </strong>
              </Flex>
            ),
            line: (
              <strong className="color-primary text-center">
                {item?.line ?? "0"}
              </strong>
            ),
            priority: (
              <strong className="color-primary text-center">
                {item?.priority ?? "0"}
              </strong>
            ),
            articlesList: (
              <Button
                onClick={() => {
                  setArticlesModalData(item);
                  setModalVisibility(
                    "MAG_HOME_PAGE_ARTICLE_LINE_ARTICLES_MODAL"
                  );
                }}
              >
                <IconEye />
                <span className="color-primary2">مشاهده لیست</span>
              </Button>
            ),
            status: (
              <Flex align="center" justify="center">
                <StatusLabel status={item.isActive} />
              </Flex>
            ),
            action: (
              <Flex gap={8} justify="center">
                <ActionButton
                  type="remove"
                  onClick={() => deleteArticleLineMutation(item.id!)}
                />
                <ActionButton
                  type="edit"
                  onClick={() => {
                    setFormData(item);
                    setIsEdit(true);
                    setModalVisibility("MAG_HOME_PAGE_ARTICLE_LINE_MODAL");
                  }}
                />
              </Flex>
            ),
          };
        }) || []
    );
  }, [data]);

  return (
    <Table
      locale={{ emptyText: "هیچ داده ای وجود ندارد" }}
      columns={MAG_HOME_ARTICLE_LINES_COLUMN}
      dataSource={dataSource}
      loading={isPending}
      pagination={false}
    />
  );
};

export default ArticleLinesTable;
